//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const BillingStatsPage: FeatureFlag = {"Id":"BillingStatsPage","Label":"Show Billing Pages","Impact":"Show the billing pages on navigation","Mode":2,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
